import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
  InjectionToken,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Font } from '@core/models/games/font.model';
import { GameParametersContainerForInjection } from '@games/core';
import {
  GAME_PARAMETERS_TOKEN,
  ParametersContainerForInjection,
} from '@games/core/parameters/container';
import { Subscription } from 'rxjs';
import { FontParametersService } from './font-parameters.service';

// export const FONT_PARAMETERS_TOKEN = new InjectionToken<ParametersContainer>(
//   'FONT_PARAMETERS_TOKEN',
// );

interface FontParameters {
  fontFamily: string;
  font: string;
  fontSize: number;
  fontWeight: 100 | 200 | 300 | 400 | 500 | 600 | 700 | 800 | 900;
}

@Component({
  selector: 'ms-font-parameters',
  templateUrl: './font-parameters.component.html',
  styleUrls: ['./font-parameters.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FontParametersComponent implements OnInit, OnDestroy, AfterViewInit {
  readonly fontSizeOptions = [100, 110, 125, 150, 175, 200, 250, 300, 400, 500];

  readonly fontWeightOptions = [100, 200, 300, 400, 500, 600, 700, 800, 900];

  @Input() set available(parameters: ('fontFamily' | 'fontSize' | 'fontWeight')[]) {
    this.availableParameters = {
      fontFamily: false,
      fontSize: false,
      fontWeight: false,
    };
    parameters.forEach((parameter) => {
      this.availableParameters[parameter] = true;
    });
  }

  public availableParameters: {
    fontFamily: boolean;
    fontSize: boolean;
    fontWeight: boolean;
  } = {
    fontFamily: true,
    fontSize: true,
    fontWeight: false,
  };

  public get fonts(): Font[] {
    return this._fontParametersService.fonts;
  }

  private readonly _subscription = new Subscription();

  protected readonly _parameters: GameParametersContainerForInjection<FontParameters>;

  get parameters() {
    return this._parameters.value;
  }

  constructor(
    private _fontParametersService: FontParametersService,
    private _cdr: ChangeDetectorRef,
  ) {
    this._parameters = inject(GAME_PARAMETERS_TOKEN);
  }

  ngOnInit(): void {
    // if (this.availableParameters.fontFamily) {
    //   if (this._fontParametersService.fontFamily !== null) {
    //     this.globalParameters.controls.font.setValue(this._fontParametersService.fontFamily);
    //   }

    //   this._subscription.add(
    //     this.globalParameters.controls.font.valueChanges.subscribe((res) => {
    //       this._fontParametersService.fontFamily = res;
    //     }),
    //   );
    // }

    // if (this.availableParameters.fontSize) {
    //   if (this._fontParametersService.fontSize !== null) {
    //     this.globalParameters.controls.fontSize.setValue(this._fontParametersService.fontSize);
    //   }

    //   this._subscription.add(
    //     this.globalParameters.controls.fontSize.valueChanges.subscribe((res) => {
    //       this._fontParametersService.fontSize = res;
    //     }),
    //   );
    // }

    // if (this.availableParameters.fontWeight) {
    //   if (this._fontParametersService.fontWeight !== null) {
    //     this.globalParameters.controls.fontWeight.setValue(this._fontParametersService.fontWeight);
    //   }

    //   this._subscription.add(
    //     this.globalParameters.controls.fontWeight.valueChanges.subscribe((res) => {
    //       this._fontParametersService.fontWeight = res;
    //     }),
    //   );
    // }

    // markForCheck когда шрифты загрузятся.
    this._subscription.add(
      this._fontParametersService.fontsLoaded.subscribe(() => this._cdr.markForCheck()),
    );
  }

  ngAfterViewInit() {}

  ngOnDestroy() {
    this._subscription.unsubscribe();
  }
}
